// eslint-disable-next-line no-restricted-imports
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import usePageViews from "@/tracking/usePageViews";

function PageViews() {
  usePageViews();
  return null;
}

/** Hands every page the client `startPostHog` started, and counts the pages. */
export default function PHProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PostHogProvider client={posthog}>
      <PageViews />
      {children}
    </PostHogProvider>
  );
}
